import posthog from 'posthog-js';
import type { AnalyticsEvent, EventName, EventProps } from './events';

let initialized = false;

export function initPostHog(apiKey: string, userId: string, organizationID: string, language: string) {
  if (!apiKey || initialized) return;
  console.log('apiKey', apiKey);
  posthog.init(apiKey, { api_host: 'https://posthog.hellonimbly.com', autocapture: false, capture_pageview: false });
  posthog.identify(userId, { organizationID, language });
  initialized = true;
}

export function identifyUser(userId: string, organizationID: string, language: string) {
  if (!initialized) return;
  posthog.identify(userId, { organizationID, language });
}

export function resetAnalytics() {
  if (!initialized) return;
  posthog.reset();
}

export function track<T extends EventName>(event: T, props: EventProps<T>): void;
export function track(event: AnalyticsEvent['name'], props: Record<string, unknown>): void {
  if (!initialized) return;
  posthog.capture(event, props);
}
